<template>
  <div class="work-list-block">
    <work-item v-for="item in list"
               :key="item.id"
               :item="item"
    />
  </div>
</template>

<script>
  import WorkItem from '@/pages/Work/components/WorkItem';

  export default {
    name: 'WorkListBlock',
    components: {
      WorkItem,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

</style>
